'use client';

import { useTranslations } from 'next-intl';
import { RightArrow } from 'assets/icons';
import { Container, CustomImage as Image } from '..';
import { H2 } from './styleConstants';
import CustomLink from 'components/shared/CustomLink';
import styles from './BlogSection.module.css';

const BlogData = [
  {
    key: 'bloodMarkers',
    image: 'web_v2/blood-vision/blogs/blogIllustration-1.png',
    link: '/blog/what-do-your-blood-markers-mean-about-your-health/',
  },
  {
    key: 'introducingBloodVision',
    image: 'web_v2/blood-vision/blogs/blogIllustration-2.png',
    link: '/blog/introducing-blood-vision-with-ultratrace/',
  },
];

export const BlogSection = ({ className }: { className?: string }) => {
  const t = useTranslations('bloodVision');

  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <H2>{t('blogs.title')}</H2>
        <p className={styles.subtitle}>{t('blogs.subtitle')}</p>

        <div className={styles.blogContainer}>
          {BlogData.map((blog, index) => {
            return (
              <div
                key={index}
                className={styles.blogElement}
                role="link"
                onClick={(e: any) => {
                  e.target.parentNode.querySelector('a')?.click();
                }}
                onKeyDown={(e: React.KeyboardEvent) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    (e.currentTarget as HTMLElement)
                      .querySelector('a')
                      ?.click();
                  }
                }}
                tabIndex={0} // Make the element tabbable
              >
                <Image
                  src={blog.image}
                  alt={t(`blogs.items.${blog.key}.title`)}
                  width="368"
                  height="355"
                />
                <hr />
                <div className={styles.textContent}>
                  <h3>{t(`blogs.items.${blog.key}.title`)}</h3>
                  <p>{t(`blogs.items.${blog.key}.description`)}</p>
                  <CustomLink
                    href={blog.link}
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {t('blogs.readMore')} <RightArrow />
                  </CustomLink>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};
